import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ThunderboltOutlined,
} from '@ant-design/icons';
import { colors } from '@/shared/tokens/colors';

const checkCircleStyle = { color: colors.green, fontSize: '16px' }
const closeCircleStyle = { color: colors.red, fontSize: '16px' }


export function getModelsColumns(word, goToTrain, currentDataset) {
    return [
        {
            title: "Model Name",
            dataIndex: 'model',
            width: '20%',
        },
        {
            title: "Knowledge Cutoff",
            dataIndex: 'knowledge_cutoff',
            width: '20%',
        },
        {
            title: "Context Size",
            dataIndex: 'context_size',
            width: '10%',
        },
        {
            title: 'Word2Token Ratio',
            dataIndex: 'word2token',
            width: '10%',
        },
        {
            title: `Is ${word} In Vocab?`,
            dataIndex: 'isInVocab',
            width: '10%',
            render: (_, record) => renderVocab(record, word),
        },
        {
            title: 'Perplexity (0 steps)',
            dataIndex: 'perplexity',
            width: '14%',
        },
        {
            title: 'Cost per 1m tokens',
            dataIndex: 'cost',
            width: '14%',
        },
        {
            title: 'Avg. Latency',
            dataIndex: 'avg_latency',
        },
        {
            title: '',
            dataIndex: 'train',
            width: '1%',
            render: (_, record) => renderTrain(record, goToTrain, currentDataset),
        },
    ]
}

function renderVocab(record, word) {
    if (word === "") {
        return ""
    }
    if (record.isInVocab) {
        return <CheckCircleOutlined style={checkCircleStyle} />
    }
    return <CloseCircleOutlined style={closeCircleStyle} />
}

function renderTrain(record, goToTrain, currentDataset) {
    return <ThunderboltOutlined onClick={() => goToTrain(currentDataset, record.model)} style={{ color: colors.buttonsBlue }} />
}